var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIngressinhoMassacoteTodos = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 211 211",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ingressinho-massacote-todos_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M98.158 208.647c17.396 0 31.499-.84 31.499-1.877s-14.103-1.877-31.499-1.877c-17.395 0-31.498.84-31.498 1.877s14.103 1.877 31.498 1.877Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.261 38.642s-.351 0-.99.023c-11.038 6.876-20.527 18.339-20.527 18.339s14.618-.6 25.696 8.126c0 0 2.466-15.427 12.215-29.315-8.545-.3-16.264 2.827-16.394 2.822v.005Z",
  fill: "#4BE76A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.104 36.149c-1.889-.046-3.823.073-5.74.435-1.894-.47-3.817-.701-5.706-.769-9.749 13.889-12.215 29.315-12.215 29.315s4.909-1.6 17.135-1.244c12.22.35 17.033 2.234 17.033 2.234s-1.572-15.54-10.502-29.971h-.005Z",
  fill: "#EDC32E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.292 39.994c.164.017.351.034.549.062-.978-.113-1.533-.141-1.533-.141-.124 0-7.656-3.569-16.201-3.767 8.929 14.426 10.501 29.972 10.501 29.972 11.565-8.07 26.126-6.634 26.126-6.634.166-1.9.166-1.9 0 0 0 0-8.816-11.994-19.436-19.492h-.006Z",
  fill: "#FF2948"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.272 38.665c-3.365.141-14.754 1.12-24.854 7.849 0 0 4.134 3.953 4.326 10.496 0 0 9.495-11.469 20.528-18.34v-.005ZM158.294 39.994c3.353.333 14.663 1.968 24.361 9.268 0 0-4.354 3.71-4.919 10.224 0 0-8.817-11.994-19.437-19.492h-.005Z",
  fill: "#0097FF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M157.302 39.914c-.153 0-11.338-5.32-21.941-3.33-10.473-2.602-21.942 2.064-22.1 2.058 0 0-13.832-.13-25.843 7.872 0 0 4.134 3.953 4.326 10.495 0 0 14.618-.599 25.696 8.127 0 0 4.909-1.6 17.135-1.244 12.22.35 17.032 2.233 17.032 2.233 11.565-8.07 26.126-6.633 26.126-6.633.572-6.52 4.92-10.224 4.92-10.224-11.53-8.68-25.345-9.348-25.345-9.348l-.006-.006Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.832 25.653c-.017-.164-.272-.17-.306-.011l-.554 3.11.616.017.617.017-.379-3.139.006.006ZM134.989 49.528a.557.557 0 0 1-.543-.577l.356-12.384a.558.558 0 0 1 .577-.543.558.558 0 0 1 .543.577l-.357 12.384a.557.557 0 0 1-.576.543Z",
  fill: "#8031FF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M134.989 49.528a.557.557 0 0 1-.543-.577l.356-12.384a.558.558 0 0 1 .577-.543.558.558 0 0 1 .543.577l-.357 12.384a.557.557 0 0 1-.576.543Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.608 97.335a.895.895 0 0 1-.865-.916l.402-13.855a.891.891 0 1 1 1.781.05l-.401 13.856a.895.895 0 0 1-.917.865Z",
  fill: "#8031FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.034 82.587a.294.294 0 0 1-.289-.305l.956-33.06c0-.163.141-.293.305-.288a.298.298 0 0 1 .289.306l-.956 33.059a.293.293 0 0 1-.305.288Z",
  fill: "#8031FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.594 28.627c-17.349 1.782-22.326 10.015-22.326 10.015.159 0 11.627-4.66 22.1-2.058 10.603-1.996 21.789 3.325 21.941 3.33 0 0-4.495-8.504-21.715-11.287Z",
  fill: "#EDC32E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.641 46.706s-3.789-3.98-3.138-11.598c.893-10.467-2.036-17.79-5.763-19.866",
  stroke: "#FF2948",
  strokeWidth: 0.566,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.43 46.39s.441-5.605-3.699-9.88c-5.683-5.864-2.844-10.275-6.084-17.23M135.288 36.522s-3.031-7.906-.747-15.62c2.669-9.008-2.047-18.327-5.79-20.55",
  stroke: "#FF2948",
  strokeWidth: 0.566,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.289 36.522s-1.29-5.163-5.452-9.653c-5.711-6.164-2.03-10.903-5.287-18.13",
  stroke: "#FF2948",
  strokeWidth: 0.566,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.36 49.087s-3.003-4.134-3.625-11.7c-.854-10.394-3.76-17.83-6.458-20.058",
  stroke: "#FF2948",
  strokeWidth: 0.584,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.484 49.036s-3.286-4.123-2.29-10.761c1.368-9.116-3.162-10.417-4.276-18.492",
  stroke: "#FF2948",
  strokeWidth: 0.584,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M133.608 97.335a.895.895 0 0 1-.865-.916l.402-13.855a.891.891 0 1 1 1.781.05l-.401 13.856a.895.895 0 0 1-.917.865Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.261 38.642s4.977-8.233 22.326-10.015c0 0-8.946.679-15.506 2.262-20.595 4.982-32.663 15.625-32.663 15.625 12.011-7.996 25.843-7.872 25.843-7.872.096 0 .096 0 0 0Z",
  fill: "#FF2948"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.941 31.783c-6.458-1.962-15.353-3.156-15.353-3.156 17.219 2.783 21.715 11.288 21.715 11.288s13.815.667 25.346 9.347c0 0-11.435-11.32-31.708-17.48Z",
  fill: "#4BE76A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.223 133.126a2.683 2.683 0 0 1-1.131-4.343l1.657-1.827c7.408-8.171 10.032-19.385 7.012-29.994l-1.391-4.88a2.68 2.68 0 0 1 1.844-3.314 2.68 2.68 0 0 1 3.314 1.844l1.391 4.88c3.534 12.407.469 25.515-8.194 35.066l-1.657 1.827a2.69 2.69 0 0 1-2.845.741Z",
  fill: "url(#ingressinho-massacote-todos_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "m138.916 95.492-.48-1.697c2.822 11.91-.334 24.294-8.618 33.427l-1.657 1.826a2.689 2.689 0 0 1-2.845.741 2.8 2.8 0 0 1-.656-.339 2.674 2.674 0 0 0 1.561 3.675 2.69 2.69 0 0 0 2.845-.74l1.656-1.827c8.664-9.557 11.729-22.665 8.194-35.066Z",
  fill: "#040006"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.901 107.322c-.074-5.921-4.829-11.265-10.62-11.932l-8.613-.99-4.128-.475-1.939 1.544.067 5.203c.012 1.063-.288 2.013-.808 2.776a4.604 4.604 0 0 1-2.28.294c-2.81-.322-5.117-2.918-5.156-5.79l-.068-5.203-2.223-.254-10.518-1.21c-2.686-.312-5.129.44-6.961 1.928.017-.012.034-.028.05-.04l-1.939 1.544c-2.149 1.713-3.483 4.428-3.444 7.628l.645 51.687c.073 5.921 4.83 11.265 10.626 11.932l10.518 1.21 2.222.254 1.94-1.543-.068-5.203c-.011-1.063.288-2.019.814-2.782a4.648 4.648 0 0 1 2.274-.289c2.81.323 5.117 2.918 5.151 5.791l.068 5.203 7.21.831 16.021 1.843 1.939-1.543-.78-62.408v-.006Z",
  fill: "url(#ingressinho-massacote-todos_svg__c)"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.4,
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M110.003 124.168c.085.011.164.028.249.051.084.028.164.062.237.102a1.432 1.432 0 0 1 .577.543c.045.079.085.158.119.237.034.079.056.164.079.255a1.294 1.294 0 0 1-.068.752c-.034.073-.068.147-.113.209a.964.964 0 0 1-.158.181 1.138 1.138 0 0 1-.9.277 1.457 1.457 0 0 1-.904-.486 1.508 1.508 0 0 1-.391-.967 1.294 1.294 0 0 1 .204-.707.933.933 0 0 1 .158-.181.977.977 0 0 1 .413-.232c.079-.023.158-.04.238-.045a1.71 1.71 0 0 1 .248 0l.012.011ZM89.643 121.821c.085.011.164.028.25.057a1.685 1.685 0 0 1 .457.243c.068.056.136.119.198.187.062.067.113.141.159.214.045.074.084.159.118.238a1.2 1.2 0 0 1 .074.254 1.312 1.312 0 0 1-.063.752 1.208 1.208 0 0 1-.113.21 1.2 1.2 0 0 1-.158.181 1.217 1.217 0 0 1-.192.141 1.043 1.043 0 0 1-.458.141c-.085.006-.17.006-.249 0a.97.97 0 0 1-.249-.056.997.997 0 0 1-.237-.102 1.106 1.106 0 0 1-.22-.147 1.958 1.958 0 0 1-.199-.187c-.062-.067-.113-.141-.164-.214a2.42 2.42 0 0 1-.119-.238c-.033-.085-.056-.17-.079-.254a1.37 1.37 0 0 1-.005-.515 1.07 1.07 0 0 1 .073-.238c.028-.073.068-.147.113-.214a.935.935 0 0 1 .159-.181c.056-.051.124-.102.192-.142a1.06 1.06 0 0 1 .22-.09c.08-.023.159-.04.238-.045a1.8 1.8 0 0 1 .254 0v.005ZM105.03 133.521c.707.08 1.284.73 1.295 1.454.045 3.591-2.776 6.181-6.288 5.779-3.512-.401-6.402-3.653-6.447-7.244-.011-.718.554-1.238 1.261-1.159.707.079 1.284.729 1.295 1.453.028 2.149 1.759 4.094 3.863 4.338 2.103.243 3.788-1.307 3.766-3.461-.012-.718.554-1.239 1.261-1.16h-.006Z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.2,
  fill: "#040006"
}, /*#__PURE__*/React.createElement("path", {
  d: "m104.597 99.128-.068-5.203-1.939 1.544.068 5.203c.011 1.063-.289 2.013-.809 2.776 1.651-.667 2.771-2.29 2.748-4.32ZM127.904 107.322l.78 62.408-16.02-1.844-7.21-.831-.062-5.202c-.034-2.873-2.347-5.463-5.152-5.791-1.77-.204-3.314.537-4.207 1.832a4.66 4.66 0 0 1 2.273-.288c2.81.322 5.118 2.918 5.152 5.79l.067 5.203 7.211.831 16.02 1.844 1.934-1.544-.78-62.408h-.006ZM93.045 165.625l-10.519-1.211c-5.79-.667-10.552-6.011-10.625-11.931l-.645-51.687c-.04-3.246 1.34-5.989 3.546-7.696-.051.04-.102.073-.153.113.017-.011.034-.028.051-.04l-1.94 1.544c-2.148 1.713-3.483 4.428-3.444 7.629l.645 51.686c.074 5.921 4.83 11.265 10.626 11.932l10.518 1.21 2.222.255 1.94-1.544-2.222-.255v-.005Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M47.06 120.029c-4.592-1.544-8.703-3.309-12.011-5.18l-3.071-1.736a2.686 2.686 0 0 1-1.012-3.659 2.68 2.68 0 0 1 3.658-1.012l3.071 1.736c6.865 3.89 18.085 7.402 29.282 9.178l2.403.379a2.68 2.68 0 0 1 2.228 3.07 2.68 2.68 0 0 1-3.07 2.228l-2.404-.379c-6.69-1.057-13.267-2.669-19.08-4.625h.006Z",
  fill: "url(#ingressinho-massacote-todos_svg__d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.552 207.686a2.77 2.77 0 0 1-2.817-2.432c-.328-2.754-2.047-4.569-4.427-7.085-2.913-3.082-6.543-6.916-8.438-13.827-2.369-8.657-1.888-16.405-1.871-16.727a2.76 2.76 0 1 1 5.508.362c-.006.136-.419 7.216 1.685 14.906 1.527 5.576 4.371 8.585 7.12 11.491 2.629 2.782 5.349 5.655 5.897 10.224a2.761 2.761 0 0 1-2.669 3.088h.012Z",
  fill: "url(#ingressinho-massacote-todos_svg__e)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M100.375 204.977c-.226-2.934-1.963-4.936-4.371-7.713-2.952-3.399-6.623-7.628-8.319-15.036-1.72-7.527-1.482-14.336-1.306-16.824a2.76 2.76 0 0 0-1.374 2.205c-.023.328-.504 8.076 1.871 16.728 1.895 6.905 5.52 10.744 8.438 13.826 2.375 2.517 4.094 4.332 4.427 7.086a2.758 2.758 0 0 0 2.817 2.432c.084 0 .169-.012.254-.017.034 0 .062-.017.091-.023a2.928 2.928 0 0 1-2.523-2.669l-.005.005Z",
  fill: "#040006"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M102.609 198.174c-.99-1.374-2.149-2.595-3.286-3.8l-.566-.599c.046 2.443-.95 3.93-1.945 5.106 1.555 1.651 1.742 2.805 2.415 4.422 1.046-1.396 2.205-3.132 3.382-5.129Z",
  fill: "#040006"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.138 206.764a2.76 2.76 0 0 1-1.69-4.999c2.34-1.685 8.725-8.573 12.864-16.84 3.591-7.171 4.518-14.375 4.53-14.449a2.76 2.76 0 0 1 3.076-2.397 2.757 2.757 0 0 1 2.398 3.076c-.04.328-1.041 8.183-5.073 16.241-4.461 8.912-11.338 16.518-14.578 18.854a2.779 2.779 0 0 1-1.533.52l.006-.006Z",
  fill: "url(#ingressinho-massacote-todos_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M115.69 169.052c0 .09 0 .181-.006.271-.045.345-1.086 8.522-5.282 16.914-4.643 9.28-11.807 17.202-15.183 19.634a2.886 2.886 0 0 1-1.505.532 2.8 2.8 0 0 0 1.425.367 2.77 2.77 0 0 0 1.533-.52c3.24-2.336 10.117-9.941 14.578-18.854 4.032-8.058 5.033-15.913 5.073-16.241a2.741 2.741 0 0 0-.633-2.103Z",
  fill: "#040006"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "m71.488 122.896-2.793-.441c-7.781-1.233-15.438-3.105-22.207-5.384-5.344-1.798-10.128-3.851-13.974-6.028l-1.781-1.012a2.674 2.674 0 0 0 1.25 3.076l3.07 1.736c3.309 1.872 7.42 3.636 12.012 5.18 5.813 1.957 12.39 3.568 19.08 4.626l2.403.379a2.675 2.675 0 0 0 3.042-2.132h-.102Z",
  fill: "#040006"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.265 125.655h-.159c-.43-.034-5.123-.305-5.49-.537l-.215-.141a3.845 3.845 0 0 1-1.567-3.778 3.84 3.84 0 0 1-1.029-3.958 3.827 3.827 0 0 1 3.11-2.658 3.829 3.829 0 0 1 3.45-2.2h.034c1.493 0 2.81.843 3.455 2.138a3.832 3.832 0 0 1 3.155 2.601 3.84 3.84 0 0 1-.95 3.981 3.84 3.84 0 0 1-1.498 3.806 3.872 3.872 0 0 1-2.302.758l.006-.012Z",
  fill: "#EDC32E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.456 120.074a1.092 1.092 0 1 0 0-2.184 1.092 1.092 0 0 0 0 2.184Z",
  fill: "#FFA426"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M43.587 116.789a3.911 3.911 0 0 0-.09 1.956c1.148.441 2.335.871 3.562 1.284 2.737.922 5.65 1.764 8.658 2.511a3.84 3.84 0 0 0 .13-1.895 3.82 3.82 0 0 0 1.103-3.336c-3.67-.916-7.182-1.985-10.383-3.156a3.831 3.831 0 0 0-2.98 2.63v.006Z",
  fill: "#040006"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.245 124.948a3.832 3.832 0 0 1-1.567-3.777 3.842 3.842 0 0 1-1.029-3.959 3.826 3.826 0 0 1 3.11-2.657 3.829 3.829 0 0 1 3.45-2.2c1.42 0 2.844.831 3.489 2.137a3.848 3.848 0 0 1 3.161 2.602 3.842 3.842 0 0 1-.956 3.981 3.823 3.823 0 0 1-1.498 3.805c-.402.306-.617.362-.814.379-2.523.21-5.514 1.001-7.346-.305v-.006Z",
  fill: "#EDC32E"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M47.245 124.948a3.832 3.832 0 0 1-1.567-3.777 3.842 3.842 0 0 1-1.029-3.959 3.826 3.826 0 0 1 3.11-2.657 3.829 3.829 0 0 1 3.45-2.2c1.42 0 2.844.831 3.489 2.137a3.848 3.848 0 0 1 3.161 2.602 3.842 3.842 0 0 1-.956 3.981 3.823 3.823 0 0 1-1.498 3.805c-.402.306-.617.362-.814.379-2.523.21-5.514 1.001-7.346-.305v-.006Z",
  fill: "#040006"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.295 120.051a1.091 1.091 0 1 0 .001-2.182 1.091 1.091 0 0 0 0 2.182Z",
  fill: "#FF873C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.135 135.008c-.135 0-.277-.028-.401-.079l-6.452-2.562a1.106 1.106 0 0 1-.69-.95c-.017-.294 0-.582.045-.87a3.838 3.838 0 0 1-1.03-3.965 3.833 3.833 0 0 1 3.111-2.657 3.829 3.829 0 0 1 3.45-2.2h.033c1.493 0 2.817.842 3.456 2.137a3.833 3.833 0 0 1 3.155 2.602 3.84 3.84 0 0 1-.95 3.981 3.829 3.829 0 0 1-1.498 3.806 3.881 3.881 0 0 1-2.206.757h-.028.005Z",
  fill: "#FF2948"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.258 129.433a1.092 1.092 0 1 0 0-2.183 1.092 1.092 0 0 0 0 2.183Z",
  fill: "#FFBC36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.566 135.037h-.063a3.831 3.831 0 0 1-2.03-.713 3.82 3.82 0 0 1-1.566-3.777 3.842 3.842 0 0 1-1.03-3.959 3.836 3.836 0 0 1 3.111-2.658 3.83 3.83 0 0 1 3.45-2.199c1.47.045 2.844.831 3.489 2.137a3.833 3.833 0 0 1 3.155 2.602 3.83 3.83 0 0 1-.956 3.981c.068.367.085.746.046 1.125a1.098 1.098 0 0 1-.696.899l-6.526 2.494c-.124.045-.26.073-.39.073l.006-.005Z",
  fill: "#FF2948"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M54.135 135.008c-.135 0-.277-.028-.401-.079l-6.452-2.562a1.106 1.106 0 0 1-.69-.95c-.017-.294 0-.582.045-.87a3.838 3.838 0 0 1-1.03-3.965 3.833 3.833 0 0 1 3.111-2.657 3.829 3.829 0 0 1 3.45-2.2h.033c1.493 0 2.817.842 3.456 2.137a3.833 3.833 0 0 1 3.155 2.602 3.84 3.84 0 0 1-.95 3.981 3.829 3.829 0 0 1-1.498 3.806 3.881 3.881 0 0 1-2.206.757h-.028.005Z",
  fill: "#040006"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.637 129.433a1.092 1.092 0 1 0-.001-2.183 1.092 1.092 0 0 0 0 2.183ZM27.584 142.439a3.852 3.852 0 0 1-1.572-3.783 3.84 3.84 0 0 1-1.024-3.959 3.826 3.826 0 0 1 3.11-2.657 3.829 3.829 0 0 1 3.45-2.2h.034c1.493 0 2.81.842 3.455 2.137a3.833 3.833 0 0 1 3.156 2.602 3.841 3.841 0 0 1-.577 3.551c-.215.515-1.595 4.06-2.019 4.337a3.891 3.891 0 0 1-3.93.221 3.829 3.829 0 0 1-4.089-.249h.006Z",
  fill: "#EDC32E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.638 137.542a1.092 1.092 0 1 0 0-2.183 1.092 1.092 0 0 0 0 2.183Z",
  fill: "#FFA426"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.32 143.158a3.86 3.86 0 0 1-2.24-.719c-.419-.299-1.9-3.941-2.11-4.416a3.872 3.872 0 0 1-.486-3.325 3.827 3.827 0 0 1 3.11-2.658 3.829 3.829 0 0 1 3.45-2.2h.034c1.493 0 2.81.843 3.455 2.138a3.832 3.832 0 0 1 3.155 2.601 3.841 3.841 0 0 1-.955 3.981 3.828 3.828 0 0 1-1.499 3.806 3.814 3.814 0 0 1-4.077.322 3.806 3.806 0 0 1-1.844.475l.006-.005Z",
  fill: "#EDC32E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.134 137.542a1.092 1.092 0 1 0 0-2.183 1.092 1.092 0 0 0 0 2.183Z",
  fill: "#FF873C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.942 139.057a3.871 3.871 0 0 0-3.15-2.601c-.633-1.266-1.922-2.036-3.41-2.143h-.084a3.892 3.892 0 0 0-3.455 2.211 3.858 3.858 0 0 0-3.105 2.669 3.8 3.8 0 0 0 1.03 3.959 3.816 3.816 0 0 0 1.571 3.783 3.77 3.77 0 0 0 4.027.249c.005 0 .011-.006.017-.012h.022a3.844 3.844 0 0 0 4.089-.328 3.77 3.77 0 0 0 1.487-3.805c1.052-1.007 1.442-2.539.961-3.982Z",
  fill: "#FF2948"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.48 140.941c0 .588-.48 1.091-1.091 1.091h-.017a1.092 1.092 0 0 1 0-2.183h.017c.61 0 1.091.481 1.091 1.092Z",
  fill: "#FFDA45"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.18,
  d: "M46.942 139.057a3.823 3.823 0 0 1-.962 3.982 3.769 3.769 0 0 1-1.487 3.805 3.846 3.846 0 0 1-4.089.328h-.022s-.011.006-.017.012v-12.865h.017c1.487.107 2.776.876 3.41 2.143a3.871 3.871 0 0 1 3.15 2.601v-.006Z",
  fill: "#040006"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.478 140.941c0 .588-.48 1.091-1.091 1.091h-.017v-2.183h.017c.61 0 1.091.481 1.091 1.092Z",
  fill: "#FFBC36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.518 112.977c.572.169 1.114.396 1.64.656a86.597 86.597 0 0 0 4.688 1.651 1.117 1.117 0 0 0-.237-1.035c-2.296-2.494-5.66-3.913-9.23-3.913h-.016c-.701 0-1.386.073-2.059.181a54.364 54.364 0 0 0 5.214 2.465v-.005ZM32.226 113.248c-.407.345-.803.707-1.159 1.103a1.078 1.078 0 0 0 .085 1.532c.198.198.458.283.724.283.305 0 .588-.13.808-.373.47-.52 1.001-.99 1.584-1.391l-2.042-1.154Z",
  fill: "#8031FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.16 113.627s4.219 3.512 4.688 1.651c.012-.051-4.688-1.651-4.688-1.651Z",
  fill: "#8031FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.513 124.564a.565.565 0 1 0-.001-1.13.565.565 0 0 0 0 1.13Z",
  fill: "#FFCE00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.761 126.041a.565.565 0 1 0 0-1.13.565.565 0 0 0 0 1.13ZM92.654 129.316a.564.564 0 1 0 .002-1.128.564.564 0 0 0-.002 1.128Z",
  fill: "#FF2948"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.901 122.891a.564.564 0 1 0 .001-1.128.564.564 0 0 0-.001 1.128ZM84.131 119.784a.564.564 0 1 0 .001-1.128.564.564 0 0 0 0 1.128ZM89.465 126.041a.565.565 0 1 0 0-1.13.565.565 0 0 0 0 1.13Z",
  fill: "#8031FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.988 128.599a.565.565 0 1 0 0-1.13.565.565 0 0 0 0 1.13ZM90.334 128.42a.565.565 0 1 0 0-1.13.565.565 0 0 0 0 1.13Z",
  fill: "#4BE76A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.385 126.869a.565.565 0 1 0 0-1.13.565.565 0 0 0 0 1.13Z",
  fill: "#F7931E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.205 130.102a.564.564 0 1 0 .001-1.128.564.564 0 0 0 0 1.128Z",
  fill: "#4BE76A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.721 120.618a.565.565 0 1 0 0-1.13.565.565 0 0 0 0 1.13Z",
  fill: "#F7931E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.402 116.377a.565.565 0 1 0 0-1.13.565.565 0 0 0 0 1.13ZM88.641 119.784a.564.564 0 1 0 .001-1.128.564.564 0 0 0 0 1.128Z",
  fill: "#4BE76A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.542 126.958a.564.564 0 1 0 0-1.128.564.564 0 0 0 0 1.128ZM88.077 127.734a.565.565 0 1 0 0-1.129.565.565 0 0 0 0 1.129Z",
  fill: "#FF2948"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.277 122.891a.564.564 0 1 0 0-1.128.564.564 0 0 0 0 1.128Z",
  fill: "#8031FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.55 122.981a.565.565 0 1 0 0-1.129.565.565 0 0 0 0 1.129Z",
  fill: "#F7931E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.42 126.041a.565.565 0 1 0-.001-1.13.565.565 0 0 0 0 1.13ZM91.147 124.806a.565.565 0 1 0 0-1.129.565.565 0 0 0 0 1.129ZM119.554 127.402a.5.5 0 1 0 0-1.001.5.5 0 0 0 0 1.001Z",
  fill: "#FFCE00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.099 128.705a.501.501 0 1 0 0-1.002.501.501 0 0 0 0 1.002ZM115.002 131.601a.501.501 0 1 0 0-1.003.501.501 0 0 0 0 1.003Z",
  fill: "#FF2948"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.325 125.919a.501.501 0 1 0 0-1.002.501.501 0 0 0 0 1.002ZM122.544 123.171a.5.5 0 1 0 0-1.001.5.5 0 0 0 0 1.001ZM117.824 128.705a.502.502 0 1 0-.002-1.004.502.502 0 0 0 .002 1.004Z",
  fill: "#8031FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.9 130.968a.501.501 0 1 0 0-1.002.501.501 0 0 0 0 1.002ZM117.06 130.809a.5.5 0 1 0 0-1.001.5.5 0 0 0 0 1.001Z",
  fill: "#4BE76A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.126 129.438a.501.501 0 1 0 0-1.002.501.501 0 0 0 0 1.002Z",
  fill: "#F7931E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.055 132.297a.501.501 0 1 0 0-1.002.501.501 0 0 0 0 1.002Z",
  fill: "#4BE76A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.252 123.904a.501.501 0 1 0 0-1.002.501.501 0 0 0 0 1.002Z",
  fill: "#F7931E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.648 120.154a.501.501 0 1 0 0-1.002.501.501 0 0 0 0 1.002ZM118.552 123.171a.501.501 0 1 0 0-1.002.501.501 0 0 0 0 1.002Z",
  fill: "#4BE76A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.215 129.517a.5.5 0 1 0 0-1.001.5.5 0 0 0 0 1.001ZM119.053 130.203a.501.501 0 1 0 0-1.002.501.501 0 0 0 0 1.002Z",
  fill: "#FF2948"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.298 125.919a.5.5 0 1 0 0-1.001.5.5 0 0 0 0 1.001Z",
  fill: "#8031FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.289 125.998a.5.5 0 1 0 0-1.001.5.5 0 0 0 0 1.001Z",
  fill: "#F7931E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.179 128.705a.502.502 0 1 0-.002-1.004.502.502 0 0 0 .002 1.004ZM116.337 127.613a.501.501 0 1 0 0-1.002.501.501 0 0 0 0 1.002Z",
  fill: "#FFCE00"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ingressinho-massacote-todos_svg__b",
  x1: 128.866,
  y1: 129.501,
  x2: 145.114,
  y2: 66.681,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0097FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#36B7FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ingressinho-massacote-todos_svg__c",
  x1: 99.426,
  y1: 169.574,
  x2: 98.485,
  y2: 95.553,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0097FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#36B7FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ingressinho-massacote-todos_svg__d",
  x1: 60.804,
  y1: 120.861,
  x2: 9.077,
  y2: 101.367,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0097FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#36B7FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ingressinho-massacote-todos_svg__e",
  x1: 85.412,
  y1: 186.622,
  x2: 104.733,
  y2: 186.086,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0097FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#36B7FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ingressinho-massacote-todos_svg__f",
  x1: 105.68,
  y1: 186.761,
  x2: 93.225,
  y2: 214.561,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0097FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#36B7FF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ingressinho-massacote-todos_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h211v211H0z"
})))));
export default SvgIngressinhoMassacoteTodos;